 
import { routes } from "../../../../routers/routes";
import Breadcrumbs from "../../../commonComponents/breadcrumbs";
import Team from "../../../home/common/Team";
import Founder from "./Founder";

const TeamContainer = () => {
  return (
    <>
      <Breadcrumbs title="Team" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <Team type="team" />
      <Founder />
    </>
  );
};

export default TeamContainer;
